import { PaletteMode } from '@mui/material';
import { createContext } from 'react';

export type MuiColorMode = PaletteMode | 'system';

export enum ColorMode {
  AUTO = 'auto',
  DARK = 'dark',
  LIGHT = 'light',
}

export const toColorMode = (mode: MuiColorMode | undefined) => {
  if (mode === 'system') {
    return ColorMode.AUTO;
  }

  if (mode === 'dark') {
    return ColorMode.DARK;
  }

  return ColorMode.LIGHT;
};

export const toMuiMode = (colorMode: ColorMode): MuiColorMode => {
  if (colorMode === ColorMode.AUTO) {
    return 'system';
  }

  if (colorMode === ColorMode.DARK) {
    return 'dark';
  }

  return 'light';
};

export interface ColorModeContextType {
  colorMode: ColorMode;
  resolvedMode: PaletteMode;
  setColorMode: (mode: ColorMode) => void;
  lockThemeChanges: () => void;
  unlockThemeChanges: () => void;
  isThemeChangeLocked?: boolean;
}

export const ColorModeContext = createContext<ColorModeContextType>({
  colorMode: ColorMode.LIGHT,
  resolvedMode: 'light',
  setColorMode: () => {},
  lockThemeChanges: () => {},
  unlockThemeChanges: () => {},
  isThemeChangeLocked: false,
});
